import React from 'react';
import { motion } from 'framer-motion';
import { FaQuestionCircle, FaClock, FaUsers, FaMicrophone, FaCheckCircle, FaTrophy, FaChartLine, FaGift, FaCoins } from 'react-icons/fa';

function Step2() {
  const boxes = [
    { id: 1, desc: "3 دقیقه طلا - باخت 1.5x" },
    { id: 2, desc: "3 دقیقه آزاد - نصف ضرر جبران" },
    { id: 3, desc: "45 دقیقه آزاد" },
    { id: 4, desc: "5 دقیقه پوند/دلار - برد 2x" },
    { id: 5, desc: "15 دقیقه بیتکوین - برد 1.5x" },
  ];

  const teams = ["Bull Masters", "Iron Bears", "Alpha Wolves", "Golden Eagles"];

  return (
    <div className="h-full overflow-auto p-6">
      <div className="max-w-7xl mx-auto space-y-4">
        {/* Header */}
        <motion.div 
          className="text-center mb-3"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ 
            type: "spring",
            stiffness: 260,
            damping: 20,
            duration: 0.8 
          }}
        >
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-2"
            style={{
              backgroundColor: "#374151",
              boxShadow: "0 4px 20px rgba(55, 65, 81, 0.5)",
            }}
          >
            <FaUsers className="text-white text-2xl" />
          </div>
          <motion.h1 
            className="text-2xl font-bold text-white mb-1"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            مرحله دوم: تشکیل تیم‌ها
          </motion.h1>
        </motion.div>

        {/* Challenge 1: Q&A */}
        <motion.div 
          className="p-4 rounded-2xl backdrop-blur-xl border"
          style={{
            backgroundColor: "rgba(31, 41, 55, 0.6)",
            borderColor: "rgba(253, 13, 14, 0.3)",
          }}
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-7 h-7 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "#374151" }}
            >
              <FaQuestionCircle className="text-white text-sm" />
            </div>
            <h2 className="text-white font-bold">چالش 1: پرسش و پاسخ</h2>
          </div>

          <div className="grid grid-cols-2 gap-2 mb-2">
            <div className="text-center p-2 rounded-xl" style={{ backgroundColor: "rgba(55, 65, 81, 0.3)" }}>
              <div className="text-amber-400 text-sm font-bold">30 ثانیه</div>
              <div className="text-gray-400 text-xs">زمان</div>
            </div>
            <div className="text-center p-2 rounded-xl" style={{ backgroundColor: "rgba(55, 65, 81, 0.3)" }}>
              <div className="text-blue-400 text-sm font-bold">همزمان</div>
              <div className="text-gray-400 text-xs">روش پاسخ</div>
            </div>
          </div>

          <p className="text-gray-300 text-xs text-right mb-2">
            سوال روی وال نمایش داده می‌شود. پاسخ‌ها گزینه‌ای هستند. <span className="text-red-400 font-bold">هیچکس حق صحبت ندارد</span> جز مجری.
          </p>

          <div className="p-2 rounded-xl" style={{ backgroundColor: "rgba(139, 92, 246, 0.1)", borderRight: "3px solid #8b5cf6" }}>
            <p className="text-purple-400 text-xs font-bold">امتیاز در تعیین کاپیتان‌ها و رده‌بندی ترنسفر مارکت تأثیرگذار است</p>
          </div>
        </motion.div>

        {/* Team Formation */}
        <motion.div 
          className="p-4 rounded-2xl backdrop-blur-xl border"
          style={{
            backgroundColor: "rgba(31, 41, 55, 0.6)",
            borderColor: "rgba(253, 13, 14, 0.3)",
          }}
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-7 h-7 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "#374151" }}
            >
              <FaUsers className="text-white text-sm" />
            </div>
            <h2 className="text-white font-bold">یارکشی و تشکیل تیم‌ها</h2>
          </div>

          <p className="text-gray-300 text-xs mb-2 text-right">
            کاپیتان‌ها به ترتیب یار می‌کشند. هر تیم حساب 10,000 دلاری دریافت می‌کند.
          </p>

          <div className="grid grid-cols-4 gap-2">
            {teams.map((team, idx) => (
              <div
                key={idx}
                className="p-2 rounded-xl text-center"
                style={{
                  backgroundColor: "rgba(55, 65, 81, 0.4)",
                  borderTop: "2px solid #374151",
                }}
              >
                <div className="text-white font-bold text-xs">{team}</div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Challenge 2: First Trade */}
        <motion.div 
          className="p-4 rounded-2xl backdrop-blur-xl border"
          style={{
            backgroundColor: "rgba(31, 41, 55, 0.6)",
            borderColor: "rgba(253, 13, 14, 0.3)",
          }}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-7 h-7 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "#374151" }}
            >
              <FaTrophy className="text-white text-sm" />
            </div>
            <h2 className="text-white font-bold">چالش 2: اولین ترید گروهی</h2>
          </div>

          <p className="text-gray-300 text-xs text-right mb-2">
            هر تیم <span className="text-amber-400 font-bold">15 دقیقه</span> فرصت دارد آزاد معامله کند. 
            بالانس و اکوییتی لحظه‌ای روی لیدربورد نمایش داده می‌شود.
          </p>

          <div className="p-2 rounded-xl" style={{ backgroundColor: "rgba(16, 185, 129, 0.1)", borderRight: "3px solid #10b981" }}>
            <p className="text-emerald-400 text-xs font-bold">رتبه‌بندی براساس سود - انتخاب باکس به ترتیب</p>
          </div>
        </motion.div>

        {/* Mystery Boxes */}
        <motion.div 
          className="p-4 rounded-2xl backdrop-blur-xl border"
          style={{
            backgroundColor: "rgba(31, 41, 55, 0.6)",
            borderColor: "rgba(253, 13, 14, 0.3)",
          }}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-7 h-7 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "#374151" }}
            >
              <FaGift className="text-white text-sm" />
            </div>
            <h2 className="text-white font-bold">5 باکس چالش</h2>
          </div>

          <div className="grid grid-cols-5 gap-2">
            {boxes.map((box) => (
              <div
                key={box.id}
                className="p-2 rounded-xl text-center"
                style={{
                  backgroundColor: "rgba(55, 65, 81, 0.3)",
                  borderTop: "2px solid #374151",
                }}
              >
                <div className="text-white font-bold text-sm mb-1">{box.id}</div>
                <div className="text-gray-400 text-xs leading-tight">{box.desc}</div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Individual Rating */}
        <motion.div 
          className="p-3 rounded-2xl backdrop-blur-xl border text-center"
          style={{
            backgroundColor: "rgba(253, 13, 14, 0.1)",
            borderColor: "rgba(253, 13, 14, 0.3)",
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          <p className="text-gray-300 text-xs">
            <span className="text-red-400 font-bold">رای فردی:</span> در چالش‌های گروهی هر نفر یک رای دارد که به ارزش او در ترنسفر مارکت اضافه/کم می‌شود
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default Step2;